import React, { useState } from "react";
import style from "./AddChannelPopUp.module.css";

import ChannelProgress from "../../pages/ChannelProgress/ChannelProgress";
import AddNewChannels from "../AddNewChannels/AddNewChannels";
import { useLocation, useNavigate } from "react-router-dom";
import { urlUpload } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import Button from "../button/Button";

const AddChannelPopUp = ({ liveStreams }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showAddChannel, setShowAddChannel] = useState(false);
  const [URL, setURL] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const endpoint = pathSegments[pathSegments.length - 1];
  const [loading, setLoading] = useState(false);

  const handleProgress = async () => {
    if (URL) {
      setLoading(true);
      const formData = new FormData();
      formData.append("video_url", URL);
      try {
        const response = await urlUpload(formData);
        if (response?.data) {
          navigate("/video", {
            state: { movieId: response?.data?.data?.video_id, name: endpoint },
          });
        }
        return response;
      } catch (error) {
        showToast(error.response.data.message, "error");
      } finally {
        setLoading(false);
      }
    }
  };

  // const handleAddNewChannel = () => {
  //   setShowPopup(false);
  //   setShowAddChannel(true);
  // };

  return (
    <div>
      {showAddChannel ? (
        <AddNewChannels onClose={() => setShowAddChannel(false)} />
      ) : (
        <>
          <div className={style.libraryBox}>Library</div>
          <div className={style.heading1}>{liveStreams ? "Live Streams" : "Live TV Channels"}</div>
          <div className={style.channelsContainer}>
            <div className={style.heading}>Stream URL</div>

            {showPopup && !showAddChannel && (
              <ChannelProgress setShowAddChannel={setShowAddChannel} />
            )}

            {!showPopup && !showAddChannel && (
              <div className={style.innerText}>
                <div className={style.paraText}>Paste Streaming URL</div>
                <div className={style.background}>
                  <input
                    className={style.name}
                    type="text"
                    placeholder="https:/"
                    onChange={(e) => setURL(e.target.value)}
                    value={URL}
                  />
                </div>
                <Button
                  loading={loading}
                  className={style.arrowIcon}
                  onClick={handleProgress}
                >
                  {liveStreams ? "Add Stream" : "Add Channel"}
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AddChannelPopUp;
